export default __webpack_public_path__ + "static/media/student.47360a9e.svg";